import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {


  constructor(
    private toastController: ToastController,
    private alertController: AlertController,
    private translate: TranslateService
  ) { }

  public async showToast(message: string, duration:number = 2500, position: 'top' | 'middle' | 'bottom' = 'bottom') {
    
    message = await this.translate.get(message).toPromise();

    const toast = await this.toastController.create({
      message,
      duration,
      position
    });

    await toast.present();
  }

  public async confirm(header: string = "COMMON.confirm.header", message?: string , buttons: {
    ok: string;
    cancel: string;
  } = {
    ok: "COMMON.confirm.ok",
    cancel: "COMMON.confirm.cancel"
  }): Promise<boolean> {
    header = await this.translate.get(header).toPromise();
    if (message) {
      message = await this.translate.get(message).toPromise();
    }

    buttons.ok = await this.translate.get(buttons.ok).toPromise();
    buttons.cancel = await this.translate.get(buttons.cancel).toPromise();
  
    return this.showAlert(header, message, buttons);
  }

  public async showAlert(header: string = "COMMON.confirm.header", message?: string , buttons: {
    ok: string;
    cancel: string;
  } = {
    ok: "COMMON.confirm.ok",
    cancel: "COMMON.confirm.cancel"
  }): Promise<boolean> {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [
        {
          text: buttons.cancel,
          role: 'cancel'
        },
        {
          text: buttons.ok,
          role: 'confirm'
        },
      ],
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
    return role == 'confirm';
  }
}
